<template>
  <v-app id="tax_form">
    <v-alert
      v-model="alertStatus"
      dismissible
      type="success"
    >We have recieved your tax exemption. Upon verification your status will be updated.</v-alert>
    <v-container grid-list-xl>
      <v-layout wrap align-center>
        <v-flex xs12 sm6 d-flex>
          <v-text-field
            v-model="data.busName"
            v-validate="'required|max:20'"
            append-icon="edit"
            :counter="20"
            :error-messages="errors.collect('busname')"
            data-vv-name="busname"
            required
            label="Business Name"
          ></v-text-field>
        </v-flex>
        <v-flex xs12 sm6 d-flex>
          <v-select
            v-model="data.exemption"
            :items="exemptionList"
            :hint="'Government'"
            label="Exemption Type"
            ref="type"
            :append-icon-cb="closeType"
          ></v-select>
        </v-flex>
      </v-layout>
      <v-layout wrap align-center>
        <v-flex xs12 sm6 d-flex>
          <v-radio-group v-model="data.cover" :mandatory="true" row>
            <v-radio label="Covers State" value="state"></v-radio>
            <v-radio label="Covers Nation" value="nation"></v-radio>
          </v-radio-group>
        </v-flex>
        <v-flex xs12 sm6 d-flex>
          <v-checkbox v-model="data.hold" label="Hold Order, mailing tax exemption form"></v-checkbox>
        </v-flex>
      </v-layout>
      <v-layout wrap align-center>
        <v-flex xs12 sm6 d-flex>
          <v-btn
            color="primary"
            :href="download"
            target="_blank"
            flat
          >
          <img :src="icon" class="download_icon" alt="">
          Download tax exemption Certificate form</v-btn>
        </v-flex>
      </v-layout>
      <v-layout wrap align-center>
        <v-flex xs6 sm6 d-flex>
          <vue-uppy-cloudinary
            preset="reqe2pqu"
            cloudName="kencove"
            :allowedFileTypes="allowedFileTypes"
            @uploaded="uploaded"
          />
        </v-flex>
        
        <v-flex xs6 sm6 d-flex>
          <v-btn v-on:click="submitForm3" class="submit">Submit</v-btn>
        </v-flex>
      </v-layout>
      <v-layout wrap align-center>
        <v-flex v-if="attachments.length!=0" xs12 sm12>
          <h3>Upload Files:</h3>
          <ul v-for="item in attachments" :key="item.etag">
            <li>{{ item.original_filename }}</li>
          </ul>
        </v-flex>
      </v-layout>
    </v-container>
  </v-app>
</template>


<script>
import VueUppyCloudinary from "vue-uppy-cloudinary";
import "vue-uppy-cloudinary/dist/lib/vue-uppy-cloudinary.min.css";

export default {
  name: "form3",
  components: {
    VueUppyCloudinary
  },
  $_veeValidate: {
    validator: "new"
  },
  data: () => ({
    data: {
      busName: "",
      exemption: "Agricultural Production",
      cust_num: "",
      username: "",
      cover: "state",
      hold: false,
      fileData: []
    },
    alertStatus: false,
    attachments: [],
    allowedFileTypes: ["image/*", "video/*", "application/*"],
    download: '',
    icon: require("../../img/Pdf-Icon.png"),
    exemptionList: [
      "Agricultural Production",
      "Resale",
      "Industrial Production Or Manufacturing",
      "Government",
      "Charitable Organization"
    ]
  }),
  created () {
		console.log(this.$route.query);
		this.data.cust_num = this.$route.query.cust_num;
    this.data.username = this.$route.query.username;
    this.download = this.$route.query.tax_form;
	},
  mounted() {
    this.$validator.localize("en", this.dictionary);
  },
  methods: {
    submitForm3() {
      this.$validator.validateAll().then(valid => {
        if (valid) {
          this.alertStatus = this.$store.dispatch("submitForm3", this.data);
        }
      });
    },
    uploaded(fileData) {
      this.attachments.push(fileData);
      this.data.fileData.push(fileData);
    },
    closeType() {
      if (this.$refs.type.isMenuActive == true)
        this.$refs.type.isMenuActive = false;
      else this.$refs.type.isMenuActive = true;
    }
  }
};
</script>




// WEBPACK FOOTER //
// tax_exemption_form.vue?2e31c694